import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import ccnyLogo from '../assets/ccny-logo-reverse-std.svg';
import Transition from 'react-transition-group/Transition';
import ShareButtons from './ShareButtons';


const MainNavMobile = ({ metaData, show, project, sections, onCloseClick, onLinkClick, onSocialShare }) => {
  const sectionList = sections.navItems.length !== 0 && sections.navItems.map((item, i) => {
    const { slug, name } = sections.bySlug[item];
    const url = `/${i + 1}/${slug}`;

    return (
      <NavLink key={slug} to={url} onClick={onLinkClick}>
        {name}
      </NavLink>
    );
  });

  const transitionStyles = {
    entering: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0, visibility: 'hidden' },
  };

  const { publisher, site: { url, title, description } } = metaData;

  return (
    <Transition in={show} timeout={100} mountOnEnter unmountOnExit>
      {state => (
        <div className="main-nav" style={{ ...transitionStyles[state] }}>
          <div className="main-nav-close" onClick={onCloseClick}>&times;</div>
          <header>
            <Link to="/" onClick={onLinkClick}>
              {project.templateOptions.headerLogoMobile ? (
                <img src={project.templateOptions.headerLogoMobile} className="header-title" alt={project.name} />
              ) : null}
            </Link>
          </header>
          <nav className="sections-list">
            {sectionList}
          </nav>

          <div className="social d-flex justify-content-between">
            {/* TODO: i18n */}
            <h3 className="mb-0">Share</h3>
            <div>
              <ShareButtons
                include={['facebook', 'twitter', 'email']}
                url={url}
                title={title}
                description={description}
                publisher={publisher}
                iconSize={30}
                fill="#e3e3e3"
                onButtonClick={onSocialShare}
              />
            </div>
          </div>


          <div className="logo">
            <a href={publisher.url}><img src={ccnyLogo} alt={publisher.name} /></a>
          </div>
        </div>
      )}
    </Transition>
  );
};

MainNavMobile.propTypes = {
  show: PropTypes.bool,
  sections: PropTypes.object,
  onCloseClick: PropTypes.func,
  onLinkClick: PropTypes.func,
  onSocialShare: PropTypes.func,
};

MainNavMobile.defaultProps = {
  show: false,
  onCloseClick: () => {},
  onLinkClick: () => {},
  onSocialShare: () => {},
};

const mapStateToProps = ({ metaData }) => ({ metaData });

export default connect(mapStateToProps)(MainNavMobile);



// WEBPACK FOOTER //
// ./src/components/MainNavMobile.js